import React, { useEffect } from 'react'
import ConnectUs from '../components/connectUs'
import Consultation from '../components/cunsoltation'
import NewContact from '../components/newContact'

export default function Contact() {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <div className='py-10 md:py-5'>
            {/* <ConnectUs /> */}
            <NewContact />
            <Consultation />
        </div>
    )
}
